import { render, staticRenderFns } from "./SalesChartsRow.vue?vue&type=template&id=2b97f3e2&scoped=true"
import script from "./SalesChartsRow.vue?vue&type=script&lang=js"
export * from "./SalesChartsRow.vue?vue&type=script&lang=js"
import style0 from "./SalesChartsRow.vue?vue&type=style&index=0&id=2b97f3e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b97f3e2",
  null
  
)

export default component.exports